import classNames from 'classnames';
import { FC, ReactNode, useEffect, useState } from 'react';
import LoadingBar from 'react-redux-loading-bar';
import { useLocation } from 'react-router-dom';
import { useAppDispatch } from 'src/app/hooks';
import { routes } from 'src/routes';
import { syncUser } from 'src/store/actions/authActions';
import { colors } from 'src/utils/colors';
import { sessionStorageHelper, StoragePrefix } from 'src/utils/localStorage';
import { useMediaQuery } from 'src/utils/useMediaQuery';
import variables from 'src/variables.module.scss';

import Sidebar from '../Sidebar/Sidebar';
import classes from './PageBody.module.scss';

export interface PageBodyProps {
  children: ReactNode;
}

const PageBody: FC<PageBodyProps> = ({ children }) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const isTablet = useMediaQuery(
    `(max-width: ${variables?.brTabletWide - 1}px)`
  );
  const sessionCollapsed = sessionStorageHelper.get<boolean>(
    StoragePrefix.SIDEBAR_COLLAPSED
  );

  const [sidebarCollapsed, setSidebarCollapsed] = useState(
    !isTablet ? sessionCollapsed ?? false : true
  );

  useEffect(() => {
    setSidebarCollapsed(!isTablet ? sessionCollapsed ?? false : true);
    // eslint-disable-next-line
  }, [isTablet, location]);

  useEffect(() => {
    dispatch(syncUser());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    document?.getElementById('page-body')?.scrollTo(0, 0);
    // eslint-disable-next-line
  }, [window.location.pathname, window.location.search]);

  return (
    <div
      className={classNames(classes.Container, {
        [classes.ErrorIndexContainer]: location.pathname === routes.ERROR_INDEX,
        [classes.SidebarCollapsed]: sidebarCollapsed,
        [classes.Tablet]: isTablet,
      })}
    >
      <LoadingBar
        style={{ backgroundColor: colors()?.colorFumisGreen1, zIndex: 5 }}
      />
      <Sidebar
        collapsed={sidebarCollapsed}
        setCollapsed={setSidebarCollapsed}
        isTablet={isTablet}
      />
      <div id="page-body">
        <div>{children}</div>
      </div>
    </div>
  );
};

export default PageBody;
